module.exports = __webpack_public_path__ + "static/media/image_74.d30742b6.png";